var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIncoming = function SvgIncoming(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 12.1 11.9",
    style: {
      enableBackground: "new 0 0 12.1 11.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "\n\t\tIncoming Call Icon\n\t")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-28.000000, -114.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M38.1,22.2l-7.6,7.4l0-4.7c0-0.2-0.1-0.4-0.3-0.6c-0.2-0.2-0.4-0.3-0.6-0.3l-0.7,0 c-0.2,0-0.5,0.1-0.6,0.3C28.1,24.5,28,24.8,28,25l0,8c0,0.2,0.1,0.4,0.3,0.6c0.2,0.2,0.4,0.3,0.6,0.3l8.2,0 c0.2,0,0.5-0.1,0.6-0.3c0.2-0.2,0.3-0.4,0.3-0.6l0-0.7c0-0.2-0.1-0.4-0.3-0.6c-0.2-0.2-0.4-0.2-0.6-0.2l-4.8,0l7.6-7.5 c0.3-0.3,0.3-0.9,0-1.2l-0.5-0.5C39,21.9,38.4,21.9,38.1,22.2L38.1,22.2z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIncoming, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/incoming.301f77dd.svg";
export { ForwardRef as ReactComponent };